import { SSRBase } from "@phosphor-icons/react/ssr";

export type { IconProps } from "@phosphor-icons/react";

type IconPropsWithDefaultProps = typeof SSRBase & {
  defaultProps?: Partial<React.ComponentProps<typeof SSRBase>>;
};

(SSRBase as IconPropsWithDefaultProps).defaultProps = {
  weight: "bold",
};

export * from "@phosphor-icons/react/ssr";
